"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const apiGlobalTypes_1 = require("api/types/apiGlobalTypes");
const AuthProvider_1 = require("src/providers/AuthProvider");
const useCompany_1 = require("src/modules/references/companies/hooks/useCompany");
const react_1 = require("react");
const CompanyAddresses_1 = tslib_1.__importDefault(require("src/modules/references/companies/views/CompanyAddresses"));
const CompanyAttributesPage_1 = tslib_1.__importDefault(require("src/modules/references/companies/views/CompanyAttributesPage"));
const CompanyBankAccounts_1 = tslib_1.__importDefault(require("src/modules/references/companies/views/CompanyBankAccounts"));
const CompanyResidencyFile_1 = tslib_1.__importDefault(require("src/modules/references/companies/views/CompanyResidencyFile"));
const CompanySignatories_1 = tslib_1.__importDefault(require("src/modules/references/companies/views/CompanySignatories"));
const Company = (props) => {
    const auth = (0, AuthProvider_1.useAuth)();
    const permissions = auth.state.data.user?.permissions || {};
    const companyHook = (0, useCompany_1.useCompany)({ companyId: props.companyId, openedCompanySidebar: props.openedCompanySidebar });
    (0, react_1.useEffect)(() => {
        return () => {
            const data = companyHook.state.data;
            if (data.id)
                props.closeCompanySideBar({
                    id: data.id,
                    label: data.attributes.name + ' - ' + data.attributes.legalStatusShortName,
                    addresses: data.addresses.map(el => ({ id: el.id, label: el.address, disabled: !el.status })),
                    bankAccounts: data.bankAccounts.map(el => ({
                        id: el.id,
                        label: el.accountNumber,
                        disabled: !el.status
                    })),
                    isResident: data.attributes.isResident === apiGlobalTypes_1.YesNoStatus.YES,
                    signatories: data.signatories.map(el => ({
                        id: el.id,
                        label: el.firstname + ' ' + el.lastname,
                        phones: el.phones.map(phone => ({ id: phone.id, label: phone.phone }))
                    }))
                });
        };
    }, [companyHook.state.data]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CompanyAttributesPage_1.default, { companyHook: companyHook, permissions: permissions, openedCompanySidebar: props.openedCompanySidebar, id: props.companyId }), companyHook.state.data.id
                && companyHook.state.data.attributes.foreignCompany
                && companyHook.state.data.attributes.isResident
                ? (0, jsx_runtime_1.jsx)(CompanyResidencyFile_1.default, { id: companyHook.state.data.id, companyHook: companyHook })
                : null, companyHook.state.data.id
                ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CompanyAddresses_1.default, { id: companyHook.state.data.id, companyHook: companyHook, permissions: permissions }), (0, jsx_runtime_1.jsx)(CompanySignatories_1.default, { id: companyHook.state.data.id, companyHook: companyHook, permissions: permissions }), (0, jsx_runtime_1.jsx)(CompanyBankAccounts_1.default, { openedCompanySidebar: props.openedCompanySidebar, id: companyHook.state.data.id, companyHook: companyHook, permissions: permissions })] })) : null] }));
};
exports.default = Company;
